import React from 'react';
export function Footer() {
  return <footer className="bg-[#030610] py-8 px-4 sm:px-6 lg:px-8 border-t border-primary-card text-center" data-id="element-57">
      <div className="max-w-7xl mx-auto" data-id="element-58">
        <p className="text-text-muted font-medium mb-2" data-id="element-59">
          GUIADIGITAL360 ™ | Química Aplicada © 2026. Todos los derechos
          reservados.
        </p>
        <p className="text-xs text-text-muted/50 max-w-2xl mx-auto" data-id="element-60">
          Este sitio no es parte del ecosistema de Meta o Facebook Inc.
        </p>
      </div>
    </footer>;
}